import { rootReducer } from '..';
import { ChanelType, SendMessageToStoreType } from '../../shared';

type RootState = ReturnType<typeof rootReducer>;

export const chatChannelsSelector = (state: RootState): ChanelType[] => state.chat.channels;

export const isEmptyModalOpenSelector = (state: RootState): boolean => state.chat.isEmptyModalOpen;

export const sendMessageToSelector = (state: RootState): SendMessageToStoreType | null => state.chat.sendMessageTo;

export const isLoadingSelector = (state: RootState): boolean => state.chat.isLoading;

export const chatErrorSelector = (state: RootState): string | null => state.chat.error;

export const isStreamChatEnabledSelector = (state: RootState): boolean => state.chat.isStreamChatEnabled;

export const unreadMessageCountSelector = (state: RootState): number => state.chat.unreadMessageCount;